import { Service } from '@estee/elc-service';
import {
    SEARCH_RESULTS,
    SEARCH_GNAV_INPUT_FIELD,
    VOICE_SEARCH
} from '@estee/elc-service-view-names';
import { ServiceInitializer } from '@estee/elc-universal-utils';

const { name, version } = __serviceInfo__;

export class SearchService extends Service {
    constructor(serviceIntializer: ServiceInitializer) {
        super(name, version, serviceIntializer);
        this.registerView(SEARCH_RESULTS, () => import('../exported/search/SearchResults'));
        this.registerView(SEARCH_GNAV_INPUT_FIELD, () =>
            import('../exported/search/SearchGnavInputField')
        );
        this.registerView(VOICE_SEARCH, () => import('../exported/search/VoiceSearch'));
    }
}
